import { render, staticRenderFns } from "./HeadlineWithToggle.vue?vue&type=template&id=2776d518&scoped=true&"
import script from "./HeadlineWithToggle.vue?vue&type=script&lang=ts&"
export * from "./HeadlineWithToggle.vue?vue&type=script&lang=ts&"
import style0 from "./HeadlineWithToggle.vue?vue&type=style&index=0&id=2776d518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2776d518",
  null
  
)

export default component.exports